module.exports = __webpack_public_path__ + "img/klarna-sofort1.1362f000.png";